import { Pagination } from "../../../../common/entity/Entity"

export enum TodoCode {
    TodoTaskCIWaitingSubmit = "CI_waiting_submit",
    TodoTaskCIWaitingApprove = "CI_waiting_approve",
    TodoTaskCIReject = "CI_reject",
    TodoTaskCRWaitingSubmit = "CR_waiting_submit",
    TodoTaskCRWaitingApprove = "CR_waiting_approve",
    TodoTaskCRReject = "CR_reject",
    TodoTaskCRNotInvite = "CR_not_invite",
    TodoTaskMemberInvite = "project_member_invite",
    TodoTaskProjectMemberWaitingApprove = "project_member_waiting_approve",
}

type BaseItem = {
    id: number
    name: string
}

type BaseCategory = {
    id: number
    code: TodoCode
    description: string
}

export type TodoTaskItem = {
    id: number
    body: string
    type: BaseCategory
    project: BaseItem
    construction: BaseItem
    colabConstruction: BaseItem
    category: BaseCategory
    createdAt: string
}

export type TodoTaskList = TodoTaskItem[]

export type TodoTaskListAll = {
    pagination: Pagination
    results: TodoTaskList
}